module.exports = {"userPoolWebClientId":"4kooklefahkt0jpdkk6frbl8q8","testUserPassword":"Passw0rd!","userPoolArn":"arn:aws:cognito-idp:us-east-2:276662185266:userpool/us-east-2_udeLEhSi0","testUserEmail":"alexvpickering@gmail.com","region":"us-east-2","userPoolId":"us-east-2_udeLEhSi0","identityPoolId":"us-east-2:d1508e4f-6e28-40b4-b017-76cd19d37bac","ServerlessDeploymentBucketName":"rnama-cognito-prod-serverlessdeploymentbucket-1rqoa19aadil8"}


//////////////////
// WEBPACK FOOTER
// ./src/config/cognito.json
// module id = 666
// module chunks = 13